module.exports = __webpack_public_path__ + "img/last.c25ed3a0.png";